// extracted by mini-css-extract-plugin
module.exports = {"popup":"AuthPopup_popup__2UOos"};